import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useAuthStore } from "@store/auth";
import { useDataStore } from "@store/user_org";
import { isGUEST } from "@helpers/accessHelpers";
import ComponentsScreen from "@screens/ComponentsScreen";
import LoginScreen from "@screens/auth/LoginScreen";
import AcceptInvitationScreen from "@screens/auth/AcceptInvitationScreen";
import SideBar from "./SideBar";
import { ErrorProvider } from "context/ErrorContext";
import { NavigationProvider } from "context/NavigationContext";
import { NotificationProvider } from "context/NotificationContext";
import SettingsScreen from "@screens/SettingsScreen";
import ProjectsScreen from "@screens/ProjectsScreen";
import ProjectScreen from "@screens/ProjectScreen";
import PartnersScreen from "@screens/PartnersScreen";
import BroadcastsScreen from "@screens/BroadcastsScreen";
import EmailsSentScreen from "@screens/EmailsSentScreen";
import HomeScreen from "@screens/HomeScreen";
import SignScreen from "@screens/SignScreen";

export default function Navigation() {
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.loading);
  const userData = useDataStore((s) => s.userData);
  const isGuest = isGUEST(userData);

  function MainLayout() {
    return (
      <div className="flex flex-row">
        <SideBar />
        <div className="flex-1">
          <Outlet /> {/* Les routes enfants s'affichent ici */}
        </div>
      </div>
    );
  }

  if (loading) {
    return <div className="bg-neutral-50 h-screen w-screen" />; // Loading state
  }

  return (
    <div className="bg-neutral-50">
      <ErrorProvider>
        <NotificationProvider>
          <BrowserRouter>
            <NavigationProvider>
              <Routes>
                {/* Public routes — accessible without authentication */}
                <Route path="/sign/:token" element={<SignScreen />} />
                <Route path="/accept-invitation" element={<AcceptInvitationScreen />} />
                {user ? (
                  <>
                    <Route element={<MainLayout />}>
                      <Route
                        path="/"
                        element={<Navigate to={isGuest ? "/projects" : "/home"} replace />}
                      />
                      <Route
                        path="/home"
                        element={isGuest ? <Navigate to="/projects" replace /> : <HomeScreen />}
                      />
                      <Route path="/projects" element={<ProjectsScreen />} />
                      <Route path="/project/:id" element={<ProjectScreen />} />
                      <Route
                        path="/partners"
                        element={isGuest ? <Navigate to="/projects" replace /> : <PartnersScreen />}
                      />
                      <Route
                        path="/broadcasts"
                        element={isGuest ? <Navigate to="/projects" replace /> : <BroadcastsScreen />}
                      />
                      <Route
                        path="/emails-sent"
                        element={isGuest ? <Navigate to="/projects" replace /> : <EmailsSentScreen />}
                      />
                      <Route path="/settings" element={<SettingsScreen />} />
                      <Route
                        path="/components"
                        element={isGuest ? <Navigate to="/projects" replace /> : <ComponentsScreen />}
                      />
                      <Route
                        path="*"
                        element={<Navigate to={isGuest ? "/projects" : "/home"} replace />}
                      />
                    </Route>
                  </>
                ) : (
                  <>
                    <Route path="/login" element={<LoginScreen />} />
                    <Route
                      path="*"
                      element={<Navigate to="/login" replace />}
                    />
                  </>
                )}
              </Routes>
            </NavigationProvider>
          </BrowserRouter>
        </NotificationProvider>
      </ErrorProvider>
    </div>
  );
}
